module.exports = __webpack_public_path__ + "img/Pearson-vue-semilite.395879a1.png";